module.exports = __webpack_public_path__ + "img/jpg0_fwsxq.6a96eae4.png";